import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProductSignupRoutingModule } from './product-signup.routing';
import { ProductSignupComponent } from './product-signup.component';
import { ProductsComponent } from './products/products.component';
import { ServicesModule } from '../../../app/services/services.module';
import { SharedModule } from '../../../app/shared/shared.module';
import { FormElementModule } from './form-element/form-element.module';
import { EquityComponent } from './products/equity/equity.component';
import { PdfImagePreviewComponent } from './form-element/document-upload/pdf-image-preview/pdf-image-preview.component';
import { PrdTermsAndConditionComponent } from './prd-terms-and-condition/prd-terms-and-condition.component';
import { FixedIncomeComponent } from './products/fixed-income/fixed-income.component';
import { MarginTradingComponent } from './products/margin-trading/margin-trading.component';
// import { ProductFormComponent } from './product-form/product-form.component';

@NgModule({
  declarations: [
    ProductSignupComponent,
    ProductsComponent,
    EquityComponent,
    PdfImagePreviewComponent,
    PrdTermsAndConditionComponent,
    FixedIncomeComponent,
    MarginTradingComponent,
  ],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, ProductSignupRoutingModule, ServicesModule, SharedModule, FormElementModule],
})
export class ProductSignupModule { }
